export default {
  assignPrintDelivery: '/printer/delivery/assign',
  printers: '/printer/delivery/get/printers',
  printerAssignments: '/printer/assignments/automatic',

  deliveryEvents: '/product/events/get/all',
  bypassEvent: '/product/events/bypass',
};
